import React from "react"

const BackToTop = () => (
<div className="flex justify-end">
	<a className="back-to-top" href="#top">Back to top ^</a>
 </div>
)

export default BackToTop
